import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useMatches } from 'react-router-dom'

interface RouteHandle {
  titleKey?: string
}

function titleKeyFromMatches(
  matches: ReturnType<typeof useMatches>,
): string | undefined {
  for (let index = matches.length - 1; index >= 0; index -= 1) {
    const handle = matches[index]?.handle as RouteHandle | undefined
    if (handle?.titleKey) return handle.titleKey
  }
  return undefined
}

/**
 * Keeps `document.title` localized and announces route changes in a polite
 * live region. Feature routes only need to add `handle: { titleKey }`.
 */
export function RouteMetadata() {
  const { t, i18n } = useTranslation()
  const matches = useMatches()
  const location = useLocation()
  const titleKey = titleKeyFromMatches(matches)
  const page = titleKey ? t(titleKey) : t('common.appName')

  useEffect(() => {
    const brand = t('common.appName')
    document.title = page === brand ? brand : `${page} · ${brand}`
  }, [i18n.language, location.pathname, page, t])

  return (
    <div className="sr-only" role="status" aria-live="polite">
      {titleKey ? t('a11y.routeAnnouncement', { page }) : ''}
    </div>
  )
}
